module.exports = __webpack_public_path__ + "static/media/The-West-Subscription-footy-icon.5c3cb5c0.webp";